export default __webpack_public_path__ + "static/media/avatarsob.08cfa176.svg";